import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  brand: null,
  currency: null,
  number: {},
  currencyConfig: {},
}

const conventionsSlice = createSlice({
  name: 'conventions',
  initialState,
  reducers: {
    setConventions: (state, action) => {
      const { brand, currency, number, currencyConfig } = action.payload
      state.brand = brand
      state.currency = currency
      state.number = number
      state.currencyConfig = currencyConfig
    },
    resetConventions: () => initialState,
  },
})

export const { setConventions, resetConventions } = conventionsSlice.actions
export default conventionsSlice.reducer
